import { createFileRoute } from '@tanstack/react-router'

import { MyAccessPage } from '@/components/Access/MyAccessPage'

/** Wiring only. */
export const Route = createFileRoute('/_app/access/')({
  component: AccessRoute,
})

function AccessRoute() {
  return <MyAccessPage />
}
